import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-counseling-button',
    imports: [],
    templateUrl: './counseling-button.component.html',
    styleUrl: './counseling-button.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CounselingButtonComponent {

}
